__turbopack_context__.v({
  "drill-back": "SSMRyW_drill-back",
  "drill-in": "SSMRyW_drill-in",
  "panel": "SSMRyW_panel",
  "root": "SSMRyW_root",
});
